<div class="side-filter" *ngIf="!showCheckedBox">
	<header class="side-filter__hero">
		<button
			type="button"
			class="side-filter__back"
			(click)="closeFilter()"
			[attr.aria-label]="'sideFilter.close' | translate"
		>
			<i class="fal fa-chevron-right" aria-hidden="true"></i>
		</button>
		<h2 class="side-filter__title">{{ 'sideFilter.title' | translate }}</h2>
		<div class="side-filter__divider" aria-hidden="true"></div>
	</header>

	<div class="side-filter__content">
		<ng-container *ngFor="let key of categoryKeys">
			<section class="side-filter__section" *ngIf="filterOptions[key]?.length">
				<div class="side-filter__section-header">
					<h3 class="side-filter__section-title">{{ 'menu.' + key | translate }}</h3>
					<button type="button" class="side-filter__clear" (click)="clearCategoryCheckbox(key)">
						{{ 'clear' | translate }}
					</button>
				</div>

				<div class="side-filter__panel" [ngClass]="'side-filter__panel--' + key">
					<app-search-input
						class="side-filter__search"
						[ngClass]="'side-filter__search--' + key"
						[placeholder]="'sideFilter.search' | translate"
						[appearance]="'standard'"
						[showButton]="false"
						[suffixIcon]="'search'"
						[showClear]="false"
						[spellcheck]="false"
						[onlyOnEnterOrButton]="false"
						[debounceOnTyping]="true"
						[debounceMs]="200"
						[value]="searchQueries[key]"
						(search)="onSearch(key, $event)"
					></app-search-input>
					<div class="side-filter__list" [ngClass]="'side-filter__list--' + key">
						<mat-checkbox
							class="side-filter__checkbox"
							*ngFor="let item of getFilteredItems(key)"
							[checked]="item.checked"
							(change)="onCheckboxChange(key, item, $event)"
						>
							{{ item.name }}
						</mat-checkbox>
					</div>
				</div>
			</section>
		</ng-container>
	</div>

	<footer class="side-filter__actions">
		<button
			type="button"
			class="btn btn-primary btn-rounded d-flex align-items-center text-nowrap"
			(click)="submitFilter()"
		>
			{{ 'sideFilter.applyFilters' | translate }}
		</button>
		<button
			type="button"
			class="btn btn-primary btn-rounded d-flex align-items-center text-nowrap"
			(click)="cleanAllCheckboxes()"
			[disabled]="!isFilterApplied"
			[ngClass]="{ disabled: !isFilterApplied }"
		>
			{{ 'sideFilter.resetFilters' | translate }}
		</button>
	</footer>
</div>
